// extracted by mini-css-extract-plugin
export default {"DashboardBrokers":"dashboardBrokers_DashboardBrokers__JJY2Q","DashboardBrokersTitle":"dashboardBrokers_DashboardBrokersTitle__cGRxL"};